<template>
  <div class="vue-tempalte">
    <div class="login-page">
      <transition name="fade">
         <div class="wallpaper-login"></div>
      </transition>

      <div class="container">
         <div class="row">
            <div class="col-lg-5 col-md-6 col-sm-8 mx-auto">
               <div class="card login" >
                 <h4 style="text-align: center;">MFU Finger Pressure Modulation Kit</h4>
                  <br>
                  <form class="form-group" @submit.prevent="loginWithProvider">
                    
                     <div class="social-icons" style="margin: 20px">
                       <button type="submit" class="btn btn-dark btn-lg btn-block"><i class="fa fa-google"/> login with gmail</button>
                      </div>
                  </form>
               </div>
            </div>
         </div>

      </div>
   </div>
  </div>
</template>
<script>
import {firestoredb} from '../config';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import {doc, setDoc } from "firebase/firestore"; 

export default {
  name: "login",
  data: function() {
            return { email: "", password: "" };
        },
  
  methods: {
    /* eslint-disable */
       loginWithProvider() {
              const provider = new GoogleAuthProvider();
              const auth = getAuth();
              signInWithPopup(auth, provider)
                .then((result) => {
                  const user = result.user;
                  console.log(user.email);
                  if (((user.email).split("@")[1])=="lamduan.mfu.ac.th"){
                    console.log("lamduan-mail !!");
                    try {
                      const UserID = user.email.split("@")[0];
                      const docRef = setDoc(doc(firestoredb, "Students", UserID.toString()), {
                        Name: user.displayName,
                        StudentID: UserID,
                        Email: user.email,
                      });
                      console.log("Document written with ID: ", docRef.id);
                    } catch (e) {
                      console.error("Error adding document: ", e);
                    }
                    this.$router.replace("/Home");
                  }
                  if(((user.email).split("@")[1])=="mfu.ac.th"){
                    console.log("Admin");
                    this.$router.replace("/HomeAdmin");

                  }
                  else{
                    alert("Please login with lamduan-mail.");
                    console.log("Worng !!");
                  }
                  // ...
                })
                .catch((error) => {
                  // Handle Errors here.
                  const errorCode = error.code;
                  const errorMessage = error.message;
                  // The email of the user's account used.
                  const email = error.email;
                  // The AuthCredential type that was used.
                  const credential = GoogleAuthProvider.credentialFromError(error);
                  // ...
                });

       }
       /* eslint-disable */
  }
}
</script>
<style scoped>
p {
  line-height: 1rem;
}

.card {
  padding: 20px;
}

.form-group input {
  margin-bottom: 20px;
}

.login-page {
  align-items: center;
  display: flex;
  height: 100vh;
}
.login-page .wallpaper-login {
  background: url(https://image.freepik.com/free-photo/spa-composition-with-care-items-light-wall_169016-1509.jpg) no-repeat center center;
  background-size: cover;
  height: 100%;
  position: absolute;
  width: 100%;
}
.login-page .fade-enter-active,
.login-page .fade-leave-active {
  transition: opacity 0.5s;
}
.login-page .fade-enter,
.login-page .fade-leave-to {
  opacity: 0;
}
.login-page h1 {
  margin-bottom: 1.5rem;
}

.error {
  animation-name: errorShake;
  animation-duration: 0.3s;
}

@keyframes errorShake {
  0% {
    transform: translateX(-25px);
  }
  25% {
    transform: translateX(25px);
  }
  50% {
    transform: translateX(-25px);
  }
  75% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}
.social-icons {
  text-align: center;
  font-family: "Open Sans";
  font-weight: 300;
  font-size: 1.5em;
  color: #222222;
}

.social-icons ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.social-icons ul li {
  display: inline-block;
  zoom: 1;
  width: 65px;
  vertical-align: middle;
  border: 1px solid #e3e8f9;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
  margin-right: 5px;
  background: #f4f6ff;
}

.social-icons ul li a {
  display: block;
  font-size: 1.4em;
  margin: 0 5px;
  text-decoration: none;
}
.social-icons ul li a i {
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -ms-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.social-icons ul li a:focus i,
.social-icons ul li a:active i {
  transition: none;
  color: #222222;
}
</style>